module.exports = __webpack_public_path__ + "static/img/goodness5.e216bfbf.png";